import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceInterface } from '../../../../interfaces/invoice.interface';

interface Props {
  doc: InvoiceInterface;
}

export const DocViewProductsTable = ({ doc }: Props) => {
  const { t } = useTranslation();

  const getToWeighLabel = useCallback(() => {
    if (doc?.productsToBeWeighed) {
      return ` (${t('PDF.PRODUCTS_TO_BE_WEIGHED_LABEL')})`;
    }
  }, [doc?.productsToBeWeighed, t]);

  return (
    <div className="tableContainer">
      <div className="normalText1 tableTitle centerTitle padding-l-4 flex1">
        {t('PDF.PRODUCT_TITLE')}
        {getToWeighLabel()}
      </div>
      <div className="normalText1 tableTitle center width80 text-center">{t('PDF.PRODUCT_QUANTITY')}</div>
      <div className="normalText1 tableTitle center width40 text-center">{t('PDF.PRODUCT_UNIT_TYPE')}</div>
      <div className="normalText1 tableTitle center width80 text-center">{t('PDF.PRODUCT_UNIT_COST')}</div>
      <div className="normalText1 tableTitle center width80 text-center">{t('PDF.PRODUCT_DISCOUNT')} %</div>
      <div className="normalText1 tableTitle center width58 text-center">{t('PDF.PRODUCT_TOTAL_CLEAN_VALUE')}</div>
      <div className="normalText1 center width60">{t('PDF.PRODUCT_VAT_PERCENTAGE')}</div>
    </div>
  );
};
